import { getRouteReportsSpendSummary } from 'shared/const/router';
import {
    popDrillHistory,
    popDrillToCrumb,
} from 'shared/lib/reports/drillHistory';

import type { SpendDrillInDimension } from '../types/spendDrillIn';
import type { NavigateFunction } from 'react-router-dom';
import type { DrillCrumb } from 'shared/lib/reports/drillHistory';

const navigateToSpendSummary = (navigate: NavigateFunction): void => {
    navigate(getRouteReportsSpendSummary(), {
        state: { fromDrillIn: true },
    });
};

export const navigateSpendDrillBack = (
    navigate: NavigateFunction,
    trail: DrillCrumb[] | undefined,
): void => {
    popDrillHistory(navigate, trail, () => navigateToSpendSummary(navigate));
};

export const navigateSpendDrillToCrumb = (
    navigate: NavigateFunction,
    crumb: DrillCrumb,
): void => {
    popDrillToCrumb(navigate, crumb, () => navigateToSpendSummary(navigate));
};

export const shouldSkipSpendBreakdownFetch = (
    pageDimension: SpendDrillInDimension,
    breakdown: SpendDrillInDimension,
    ids: string[] | undefined,
): boolean => pageDimension !== breakdown && ids?.length === 1;
